import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import API from "../../../../../../../apiService";
import ALERT from "../../../../../../component/Alert";
import ReactToPrint from "react-to-print";
import moment from "moment";

export default class GetClinic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        patient_id: this.props.location.param
          ? this.props.location.param?.id
          : "",
        clinic_id: "",
        user_id: this.props.location.param
          ? this.props.location.param.profilpkm?.data?.users?.id
          : "",
        puskesmas_id: this.props.location.param
          ? this.props.location.param.puskesmas_id
          : "",
        visit_date: this.props.location.param
          ? this.props.location.param?.visit_date
          : "",
      },
      clinic: [],
      subClinic: [],
      modalShow: false,
      modalPrintShow: false,
      tracer: null,
      selectedClinic: null,
    };
    this.selectedClinic = this.selectedClinic.bind(this);
  }
  componentDidMount() {
    if (this.props.location.param) {
      let clinic = [];
      let mergeClinic = [];
      this.props.location.param.clinic.map((data, ky) => {
        clinic.push(data.clinic);
      });
      clinic.map((dat, k) => {
        let x = [];
        let sub = [];
        if (dat.parent_id === 0) {
          x = dat;
          sub = clinic.filter((e) => e.parent_id === dat.id);
          if (sub.length > 0) {
            x.child = [sub];
          } else {
            x.child = null;
          }
          // x.child = [sub];
          mergeClinic.push(x);
        }
      });
      this.setState({ clinic: mergeClinic });
    } else {
      this.props.history.push("/service/puskesmas");
    }
  }
  modalShow = (child, id, data) => (e) => {
    if (child !== null) {
      this.setState({
        subClinic: child[0],
        modalShow: true,
      });
    } else {
      this.setState({ selectedClinic: data }, () => this.postPendaftaran(id));
    }
  };
  selectedClinic(data) {
    this.setState({ selectedClinic: data });
  }
  postPendaftaran = async (clinic_id) => {
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        clinic_id: clinic_id,
      },
    }));
    setTimeout(async () => {
      let param = this.state.data;
      console.log(param);
      const res = await API.post("/standalone/create", param);
      if (res.code === 200) {
        this.setState({
          tracer: res.data,
          modalPrintShow: true,
        });
      } else {
        ALERT("error", res.status);
      }
    }, 100);
  };
  render() {
    console.log(this.props.location.param);
    let modalPrintShow = this.state.modalPrintShow;
    let modalShow = this.state.modalShow;
    let clinic = this.state.clinic.map((data, key) => {
      return (
        <div
          key={key}
          onClick={this.modalShow(data.child, data.id, data)}
        >
          <div className="col-md-12 col-xl-12">
            <div className="card">
              <div className="card-body ">
                <div className="text-center">
                  <img
                    className="avatar avatar-xl align-center"
                    src={data.file_image}
                    alt=""
                  />
                </div>
              </div>
              <div className="card-footer " style={{ textAlign: "center" }}>
                {data.name}
              </div>
            </div>
          </div>
        </div>
      );
    });
    return (
      <div className="main-content h-100vh">
        <div className="container-fluid">
          <div className="container">
            <div className="row align-item-center text-left">
              <div className="col-lg-12 my-6">
                <h1 className="display-3 text-info">PILIH KLINIK TUJUAN</h1>
                <h4 className="lead">
                  Selamat Datang {this.props.location.param ? this.props.location.param.name : ''} , silahkan pilih klinik yang anda inginkan untuk kunjungan {this.props.location.param ? this.props.location.param.visit_date : ''}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid h-100vh pt-2  bg-white shadow-lg">
          <div className="container px-5">
            <div className="row">

              <div className="row">{clinic}</div>

            </div>
          </div>
        </div>
        {modalShow ? (
          <ModalSubClinic
            show={modalShow}
            onHide={() => this.setState({ modalShow: false })}
            data={this.state.subClinic}
            post={this.postPendaftaran}
            clinic={this.selectedClinic}
          />
        ) : (
            ""
          )}

        {modalPrintShow ? (
          <PrintQueue
            show={modalPrintShow}
            onHide={() => this.setState({ modalPrintShow: false })}
            data={this.state.tracer}
            clinic={this.state.selectedClinic}
            pkm={this.props.location.param.profilpkm}
            history={this.props.history}
          />
        ) : (
            ""
          )}
      </div>
    );
  }
}

export class ModalSubClinic extends Component {
  render() {
    let clinic = this.props.data.map((data, key) => {
      return (
        <div
          key={key}
          className="card col-md-12"
          onClick={() => {
            this.props.clinic(data);
            this.props.post(data.id);
          }}
        >
          <div className="card-body ">
            <div className="text-center">
              <img
                className="avatar avatar-xl align-center"
                src={data.file_image}
                alt=""
              />
            </div>
          </div>
          <div className="card-footer " style={{ textAlign: "center" }}>
            {data.name}
          </div>
        </div>
      );
    });
    return (
      <div>
        <Modal {...this.props} size="lg" aria-labelledby="modal-sub-clinic">
          <ModalHeader closeButton>
            <ModalTitle id="modal-klinik">Pilih Sub Klinik</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">{clinic}</div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="row">
              <button
                type="button"
                onClick={this.props.onHide}
                className="btn btn-danger"
              >
                tutup
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export class PrintQueue extends Component {
  render() {
    return (
      <div>
        <Modal {...this.props} size="lg" aria-labelledby="modal-print">
          <ModalHeader closeButton>
            <ModalTitle id="modal-print">
              Selamat anda telah berhasil terdaftar
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div className="card col-md-12">
              <div className="row">
                <div className="col-md-6">no Antrian</div>
                <div className="col-md-6">{this.props.data.queue}</div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div style={{ marginLeft: "1%" }}>
              <ReactToPrint
                trigger={() => <button className="btn btn-success">cetak</button>}
                content={() => this.componentRef}
                onAfterPrint={() =>
                  this.props.history.push("/service/puskesmas")
                }
              />
              <div style={{ display: "none" }}>
                <Tracer
                  ref={(el) => (this.componentRef = el)}
                  data={this.props.data}
                  clinic={this.props.clinic}
                  pkm={this.props.pkm}
                  history={this.props.history}
                />
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export class Tracer extends Component {
  render() {
    let dateStr = new Date(),
      timeStr = this.props.pkm.data.open_time,
      date = moment(dateStr),
      time = moment(timeStr, "HH:mm A");

    date.set({
      hour: time.get("hour"),
      minute: time.get("minute"),
      second: time.get("second"),
    });
    let antrian = this.props.data.queue.substring(1, 4);
    let minutes = (parseInt(antrian) - 1) * this.props.clinic.delay;
    let WaitingTime = moment(date).add(minutes, "minutes").format("hh:mm A");
    console.log(
      this.props.pkm.data.open_time,
      dateStr,
      antrian,
      minutes,
      WaitingTime
    );
    return (
      <div>
        <table>
          <tr>
            <td
              colSpan={2}
              style={{ alignContent: "center", textAlign: "center" }}
            >
              <img
                className="avatar"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Sleman.png/225px-Sleman.png"
                alt="img"
              />
            </td>
          </tr>
          <tr>
            <td colSpan={2} style={{ fontSize: "16px", textAlign: "center" }}>
              {this.props.pkm.data.name}
            </td>
          </tr>
          <tr>
            <td colSpan={2} style={{ fontSize: "10px", textAlign: "center" }}>
              {this.props.pkm.data.villages.name.toLowerCase() +
                ", " +
                this.props.pkm.data.villages.district.name.toLowerCase() +
                ", " +
                this.props.pkm.data.villages.district.city.name.toLowerCase()}
              <br></br>
              <br></br>
            </td>
          </tr>
          <tr>
            <td colSpan={2} style={{ fontSize: "24px", textAlign: "center" }}>
              {this.props.data.queue}
              <br></br>
              <br></br>
            </td>
          </tr>
          <tr>
            <td colSpan={2} style={{ fontSize: "14px", textAlign: "center" }}>
              {" "}
              {this.props.clinic.name}
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ fontSize: "12px", textAlign: "center" }}>
              silahkan datang pukul : {WaitingTime}
            </td>
          </tr>
        </table>
      </div>
    );
  }
}
